<template>
<div>
    <div class="col-md-12">
        <div class="panel">
            <div class="panel-body flex-row" style="gap:8px;align-items:center;flex-wrap:wrap">
                <label class="control-label" style="margin:0">Dispatched from</label>
                <input class="form-control input-small" type="date" v-model="fromdate" style="width:160px"/>
                <label class="control-label" style="margin:0">to</label>
                <input class="form-control input-small" type="date" v-model="todate" style="width:160px"/>
                <select class="form-control input-small" v-model="status" style="width:170px">
                    <option value="">All status</option>
                    <option value="3">Dispatched - to accept</option>
                    <option value="4">On the way</option>
                    <option value="5">Delivered</option>
                    <option value="6">Rejected</option>
                </select>
                <button class="btn btn-primary btn-sm" @click="refresh()">Search</button>
                <button class="btn btn-default btn-sm" @click="clear()">Clear</button>
                <span style="margin-left:auto">
                    <span class="control-label">Total:</span>
                    <span class="badge bg-danger">{{ orders.length }}</span>
                    <button @click="refresh()" class="btn btn-refresh"><i class="fa fa-refresh"></i></button>
                </span>
            </div>
        </div>
    </div>
    <div class="col-md-12">
        <p class="text-muted">
            {{ isadmin ? 'All dispatched orders' : 'Orders you dispatched' }} and their current delivery status.
        </p>
        <div class="panel">
            <div class="table-responsive panel-body">
                <table class="table users-table table-condensed table-hover table-bordered table-sm">
                    <thead class="table-font" style="font-size:13px;">
                        <tr>
                            <th>#</th>
                            <th>Order No.</th>
                            <th>Customer</th>
                            <th>Mobile</th>
                            <th>Product</th>
                            <th v-if="isadmin">Dispatcher</th>
                            <th>Dispatched On</th>
                            <th>Delivery Boy</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody class="table-font" style="font-size:13px;">
                        <tr v-if="!loading && orders.length == 0">
                            <td :colspan="isadmin ? 9 : 8" class="text-center">No dispatched orders</td>
                        </tr>
                        <tr v-for="(item, index) in orders" :key="item.id">
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.complaintno }}<br>{{ moment(item.created_at).format('DD-MM-YYYY') }}</td>
                            <td>
                                <span v-if="item.customer">{{ item.customer.name }}<br>{{ item.customer.generatedid }}</span>
                                <span v-else>{{ item.customername }}</span>
                            </td>
                            <td>
                                <display-mobiles v-if="item.customer" :mobiles="item.customer.mobiles"></display-mobiles>
                                <span v-else>{{ item.customermobile }}</span>
                            </td>
                            <td>
                                {{ item.product?.category?.name }} {{ item.product?.name }}
                                <div v-if="item.serialno" style="font-size:11px">Serial no.: {{ item.serialno }}</div>
                            </td>
                            <td v-if="isadmin">{{ item.followby?.name || '-' }}</td>
                            <td>{{ item.dispatchtime ? moment(item.dispatchtime).format('DD-MM-YYYY hh:mm A') : '-' }}</td>
                            <td>{{ item.deliveryboy?.name || '-' }}</td>
                            <td>
                                <span class="label" :class="statusClass(item)">{{ statusLabel(item) }}</span>
                                <div v-if="item.status == 4 && item.estimated_delivery_at" style="font-size:11px">
                                    Delivery by: {{ moment(item.estimated_delivery_at).format('DD-MM-YYYY hh:mm A') }}
                                </div>
                                <div v-if="item.status == 5" style="font-size:11px">
                                    {{ item.deliveredby?.name }} {{ moment(item.updated_at).format('DD-MM-YYYY hh:mm A') }}
                                </div>
                                <div v-if="item.status == 6 && item.return_receivedbyid > 0" style="font-size:11px">
                                    Received by {{ item.returnreceivedby?.name }}
                                </div>
                                <div v-if="item.isdispose == 1" style="font-size:11px" class="text-muted">Closed</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import DisplayMobiles from '../../components/mobile/DisplayMobiles.vue'
// Dispatch & Returns > Dispatched: orders dispatched by the logged-in employee
// (admins: all) with the delivery boy and current status, by dispatch date.
export default {
    components: { DisplayMobiles },
    data() {
        return {
            moment: moment,
            orders: [],
            loading: false,
            fromdate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
            todate: moment().format('YYYY-MM-DD'),
            status: ''
        }
    },
    computed: {
        ...mapGetters(['loggedinuser']),
        isadmin() {
            return (this.loggedinuser?.role ?? 0) > 1
        }
    },
    mounted() {
        this.refresh()
    },
    methods: {
        statusLabel(item) {
            if (item.status == 6 && item.return_receivedbyid > 0) return 'Returned to Store'
            return { 3: 'Dispatched - to accept', 4: 'On the way', 5: 'Delivered', 6: 'Rejected' }[item.status] ?? ''
        },
        statusClass(item) {
            if (item.status == 6 && item.return_receivedbyid > 0) return 'label-info'
            return { 3: 'label-warning', 4: 'label-primary', 5: 'label-success', 6: 'label-danger' }[item.status] ?? 'label-default'
        },
        clear() {
            this.fromdate = ''
            this.todate = ''
            this.status = ''
            this.refresh()
        },
        refresh() {
            this.loading = true
            this.$store.commit('assignloadingstatus', 1)
            this.$http.post('api/vsdigi/leads/orders/dispatched',
                { fromdate: this.fromdate, todate: this.todate, status: this.status })
                .then((response) => {
                    this.orders = response.data || []
                })
                .catch((err) => {
                    console.log(err)
                    this.$notify({ text: err.response?.data?.message || 'Unable to load orders', type: 'error' })
                })
                .finally(() => {
                    this.loading = false
                    this.$store.commit('assignloadingstatus', 0)
                })
        }
    }
}
</script>
